import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "@ui5/webcomponents/dist/Bar.js";
import "@ui5/webcomponents/dist/Button.js";
import "@ui5/webcomponents/dist/Popover.js"; // Import Popover
import "@ui5/webcomponents/dist/List.js"; // Import List
import "@ui5/webcomponents-icons/dist/log.js"; // Import log icon if needed for logout button
import { Popover, Typography, Button, List, ListItemButton, ListItemText } from "@mui/material";
// import { clearSiteCache } from '../utils/cacheManager.js';
const version = '1.1.64'

const HeaderBar = () => {
  const navigate = useNavigate(); // Initialize navigate
  const userRole = parseInt(localStorage.getItem("userRole"), 10);
  const firstName = localStorage.getItem("userFirstName");
  const lastName = localStorage.getItem("userLastName");
  const userFullName = firstName && lastName ? `${firstName} ${lastName}` : "User"; // Combine names or use default

  const [popoverOpen, setPopoverOpen] = useState(false);
  const nameButtonRef = useRef(null);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // Close popover when clicking outside - Moved before the early return
  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if the popover exists in the DOM before accessing contains
      const popover = document.getElementById("user-popover");
      // Ensure nameButtonRef.current exists before accessing contains
      if (popover && nameButtonRef.current && !popover.contains(event.target) && !nameButtonRef.current.contains(event.target)) {
        setPopoverOpen(false);
      }
    };

    if (popoverOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [popoverOpen]); // Dependency array remains the same

  // Handle internet connectivity status
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(true);
      // Hide banner after 5 seconds
      setTimeout(() => setShowBanner(false), 5000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [])

  // Hide HeaderBar if userRole is not set (or names are missing, indicating not logged in properly)
  if (!userRole || !firstName || !lastName) {
    return null;
  }

  const handleNameClick = (event) => {
    setPopoverOpen(!popoverOpen);
  };

  const handleLogout = () => {
    // Clear user data from localStorage
    localStorage.removeItem("userRole");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userId");
    localStorage.removeItem("userFirstName");
    localStorage.removeItem("userLastName");
    localStorage.removeItem("barangayCode");
    localStorage.removeItem("municipalCode");
    localStorage.removeItem("provincialCode");

    setPopoverOpen(false); // Close popover

    // Force navigation to the root page and reload
    window.location.href = '/';
  };

  const handleClearCache = async () => {
    const confirmed = window.confirm(
      'This will clear all cached data and reload the page. Continue?'
    );
    
    if (confirmed) {
      console.log("Clearing cache")
      // await clearSiteCache(); // Will auto-reload
    }
    console.log("Cache Cleared. Logged out!")
  }

  return (
    <div style={{
      position: "sticky",
      top: "0",
      zIndex: "1000",
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    }}>
      <ui5-bar design="Header" style={{ width: "100%" }}>
        <div slot="startContent" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <ui5-button design="Transparent" onClick={() => window.location.href = "/overview"}>Overview</ui5-button>
          <ui5-button design="Transparent" onClick={() => window.location.href = "/mass-upload"}>Mass Upload</ui5-button>
          <ui5-button design="Transparent" onClick={() => window.location.href = "/capture-upload-image"}>Capture/Upload Image</ui5-button>
          {userRole === 1 && ( // Conditionally render User Maintenance button
            <ui5-button design="Transparent" onClick={() => window.location.href = "/user-maintenance"}>User Maintenance</ui5-button>
          )}
          <ui5-button design="Transparent" onClick={() => window.location.href = "/manual-entry"}>Manual Entry</ui5-button>
          {userRole === 1 && (
            <ui5-button design="Transparent" onClick={() => window.location.href = "/migrate"}>Migrate</ui5-button>
          )}
          {(userRole === 1 || userRole === 2 || userRole === 3 || userRole === 4) && (
            <ui5-button design="Transparent" onClick={() => window.location.href = "/reports"}>Reports</ui5-button>
          )}
          {(userRole === 1 || userRole === 2 || userRole === 3 || userRole === 4) && (
            <ui5-button design="Transparent" onClick={() => window.location.href = "/opt-merge"}>OPT Merge</ui5-button>
          )}
          {userRole === 1 && (
            <ui5-button design="Transparent" onClick={() => window.location.href = "/delete-request"}>Delete Requests</ui5-button>
          )}
          {userRole === 1 && (
            <ui5-button design="Transparent" onClick={() => window.location.href = "/delete-heads"}>Delete Heads</ui5-button>
          )}
          
        </div>
        <div slot="endContent" style={{ display: "flex", alignItems: "center" }}>
          <Button variant="text" onClick={handleOpen} style={{fontWeight: 'bold', }}>
            {userFullName}
          </Button>
        </div>
      </ui5-bar>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <List sx={{ width: 150 }}>
          <ListItemButton onClick={handleLogout}>
            <ListItemText primary="Logout" />
          </ListItemButton>
          <ListItemButton onClick={handleClearCache}>
            <ListItemText primary="Clear Cache" />
          </ListItemButton>
          <ListItemButton disabled>
            <ListItemText primary={`Version ${version}`} />
          </ListItemButton>
        </List>
      </Popover>
      {showBanner && <div
        style={{
          textAlign: "center",
          padding: "8px",
          backgroundColor: isOnline ? "#84ab85ff" : "#f6b6b2ff",
          color: "black",
          fontWeight: "bold",
          position: "sticky",
          top: 60, // adjust based on your navbar height
          zIndex: 1000,
          transition: "opacity 0.5s ease",
        }}
      >
        {isOnline ? "✅ You are back online" : "⚠️ You are currently offline"}
      </div>}
    </div> 
  );
};

export default HeaderBar;
